export default __webpack_public_path__ + "locales/zh-CN/JavascriptSdk.json?hash=c52046af95c3c906af603d041a45529a";